// WebGL displacement shader for psychedelic background effect
var vsrc = '\
  attribute vec2 pos;\
  varying vec2 uv;\
  void main() {\
    uv = pos * 0.5 + 0.5;\
    gl_Position = vec4(pos, 0.0, 1.0);\
  }';

var fsrc = '\
  precision highp float;\
  varying vec2 uv;\
  uniform sampler2D tex;\
  uniform float time;\
  void main() {\
    vec2 st = uv;\
    float speed = 0.4;\
    float intensity = 0.012;\
    float dx = -sin(st.y*6.0+time*speed)*intensity - sin(st.y*12.0-time*speed*0.7)*intensity*0.5 - cos(st.x*8.0+time*speed*0.5)*intensity*0.3;\
    float dy = -cos(st.x*6.0+time*speed*0.8)*intensity - cos(st.x*10.0-time*speed*0.6)*intensity*0.5 - sin(st.y*9.0+time*speed*0.4)*intensity*0.3;\
    gl_FragColor = texture2D(tex, st + vec2(dx, dy));\
  }';

function initWebGL(canvasId, bgSrc) {
  var canvas = document.getElementById(canvasId);
  var gl = canvas.getContext('webgl');

  function resize() {
    canvas.width = window.innerWidth * devicePixelRatio;
    canvas.height = window.innerHeight * devicePixelRatio;
    gl.viewport(0, 0, canvas.width, canvas.height);
  }
  resize();
  window.addEventListener('resize', resize);

  function createShader(type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src);
    gl.compileShader(s);
    return s;
  }

  var prog = gl.createProgram();
  gl.attachShader(prog, createShader(gl.VERTEX_SHADER, vsrc));
  gl.attachShader(prog, createShader(gl.FRAGMENT_SHADER, fsrc));
  gl.linkProgram(prog);
  gl.useProgram(prog);

  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,1,1]), gl.STATIC_DRAW);

  var posLoc = gl.getAttribLocation(prog, 'pos');
  gl.enableVertexAttribArray(posLoc);
  gl.vertexAttribPointer(posLoc, 2, gl.FLOAT, false, 0, 0);

  var timeLoc = gl.getUniformLocation(prog, 'time');

  var texture = gl.createTexture();
  var img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = function() {
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    loop(0);
  };
  img.src = bgSrc;

  function loop(t) {
    gl.uniform1f(timeLoc, t * 0.001);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    requestAnimationFrame(loop);
  }
}
